<template>
  <AdvancedTooltip
      theme="blue"
      placement="top"
      title="Legal Holidays Calendar">
    <IconCalendar class="-mb-2 w-7 h-7 cursor-pointer"></IconCalendar>
  </AdvancedTooltip>
</template>
<script setup lang="ts">
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";
import IconCalendar from "@/components/svg_icons/IconCalendar.vue";

</script>